var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lc-chop-simple',_vm._b({class:_vm.$options.name,attrs:{"text":"APPROVED"}},'lc-chop-simple',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }